import { FormSectionHandler } from '../entity.handler';
import { AssetUpdateRequest, CustomFieldValues, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField, customFieldToFormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';
interface EditorValues {
    [key: string]: any;
}

export class CustomFieldsSectionHandler<T extends { id: string, assetType?: IdName, fields?: CustomFieldValues }> implements FormSectionHandler<T, EditorValues> {

    type = 'form';
    icon = 'book-open';
    bulk = true;
    hidden = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public entityType: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.SHARED.INFORMATION.${key}`, values);
    }

    applyUpdate(entity: T, payload: any): Promise<any> {
        switch (this.entityType) {
            case 'asset': return this.admin.applyUpdate(api => api.entities.updateAsset(entity.id, payload));
            case 'simcard': return this.admin.applyUpdate(api => api.entities.updateSimCard(entity.id, payload));
            case 'device': return this.admin.applyUpdate(api => api.entities.updateDevice(entity.id, payload));
            case 'assettag': return this.admin.applyUpdate(api => api.entities.updateAssetTag(entity.id, payload));
            default:
                throw new Error(`Update for '${this.entityType}' not yet supported`);
        }
    }

    mapEntityToEditor(entity: T): Promise<EditorValues> {
        return Promise.resolve({ ...entity.fields });
    }

    mapEditorToEntity(entity: AssetUpdateRequest, values: EditorValues): Promise<AssetUpdateRequest> {
        entity.fields = entity.fields || {};
        Object.keys(values).forEach(key => {
            entity.fields[key] = values[key];
        });
        return Promise.resolve(entity);
    }

    getFields(entity: T): Promise<FormBuilderField[]> {
        const whiteList = [];
        return Promise.all([
            this.admin.getCached(`getClient/${this.ownerId}`, api => api.accounts.getClient(this.ownerId)),
        ]).then(([client]) => {
            return [
                ...client.customFields[this.entityType] || [],
                ...(entity && entity.assetType && client.customFields[entity.assetType.id]) || [],
            ].map(customField => {
                whiteList.push(customField.id);

                return customFieldToFormBuilderField(customField, this.admin.units);

            });
        }).then(fields => EntityUtils.prepareBulk(!entity, whiteList, fields)).then(fields => {
            this.hidden = (fields.length === 0);
            return fields;
        });

    }




}
